<script setup lang="ts">
import { QuestionsAccordion } from '~/components/QuestionsAccordion';

import { CREDIT_FAQ } from '../content';
import { CreditSectionTitle } from '../CreditSectionTitle';
</script>

<template>
	<section class="border-t border-[#1F1F1F] bg-[#0D0D0D] px-6 py-26">
		<div class="mx-auto max-w-[880px]">
			<CreditSectionTitle>Perguntas frequentes</CreditSectionTitle>
			<div class="mt-10 flex flex-col">
				<QuestionsAccordion
					:questions="CREDIT_FAQ"
					variant="dark"
					accordion-trigger-as="div"
				/>
			</div>
		</div>
	</section>
</template>
